import { takeEvery, call, put } from 'redux-saga/effects';
import { SIGN_IN, SIGN_OUT, CHECK_AUTH } from 'store/actionTypes';
import { SignInService, SignOutService, CheckAuth, SignInWithCustomTokenService } from 'store/services/user';
import { message } from 'antd';
import fb from 'firebase';

// watchers
export function* SignInWatcher() {
  yield takeEvery(SIGN_IN.WATCH, SignInWorker);
}

export function* SignOutWatcher() {
  yield takeEvery(SIGN_OUT.WATCH, SignOutWorker);
}
// workers

function* SignInWorker(data) {
  try {
    const { payload, type } = data;
    yield put({ type: SIGN_IN.LOAD });
    const response = yield call(SignInService, payload.data);
    const token = yield response.user.getIdToken();
    yield put({ type: SIGN_IN.SUCCESS, payload: token });
    sessionStorage.setItem('auth', token);
    payload.cb && payload.cb();
  } catch (e) {
    console.error('catch', e);
    message.error(e.message);
    yield put({ type: SIGN_IN.FAIL });
  }
}


function* SignOutWorker(data) {
  try {
    const { payload, type } = data;
    yield put({ type: SIGN_OUT.LOAD });
    const response = yield call(SignOutService);
    yield put({ type: SIGN_OUT.SUCCESS, payload });
    sessionStorage.removeItem('auth');
    payload.cb && payload.cb();
  } catch (e) {
    message.error(e.message);
    console.error('catch', e);
    yield put({ type: SIGN_OUT.FAIL });
  }
}